export const isTimestampNewer = (patchTimestamp: string, serverTimestamp: string): boolean => {
  const patchTime = new Date(patchTimestamp).getTime();
  const serverTime = new Date(serverTimestamp).getTime();
  return patchTime > serverTime;
};
